export default __webpack_public_path__ + "static/media/11AW4NOV65.0fe27dca.jpg";